import React from 'react';
import { Heart, Award, Users, Sparkles } from 'lucide-react';

const AboutSection = () => {
  const highlights = [
    { icon: Heart, text: "Child-Centered Approach", color: "from-red-500 to-pink-500" },
    { icon: Award, text: "Quality Education", color: "from-yellow-500 to-orange-500" },
    { icon: Users, text: "Experienced Faculty", color: "from-blue-500 to-indigo-500" },
    { icon: Sparkles, text: "Day Care Services", color: "from-purple-500 to-pink-500" }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white via-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Welcome to <span className="text-blue-600">Gyanodeepti School & Day Care</span>
            </h2>
            <div className="w-24 h-1 bg-yellow-400 mx-auto rounded-full" />
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            {/* Left: Content */}
            <div className="space-y-6">
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                At <span className="font-semibold text-blue-600">Gyanodeepti School & Day Care</span>, we believe every child is unique and deserves the best foundation for their educational journey. Located in the heart of Sonipat, we provide a nurturing environment where young minds flourish through play, exploration, and discovery.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                Our comprehensive programs from <span className="font-semibold text-blue-600">Playgroup to Class 5, along with full-day care services</span>, combine traditional values with modern teaching methodologies. With a focus on safety, individual attention, and holistic development, we ensure that each child receives the care and guidance they need to grow.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                We take pride in our experienced teaching staff, activity-based learning curriculum, safe day care environment, and hygienic campus equipped with modern facilities.
              </p>
            </div>

            {/* Right: Image */}
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-500">
                <img 
                  src="/WhatsApp Image 2026-04-15 at 1.39.02 PM.jpeg"
                  alt="Happy students"
                  className="w-full h-full object-contain"
                />
              </div>
              {/* Decorative Element */}
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-yellow-400 rounded-3xl -z-10"></div>
              <div className="absolute -top-4 -left-4 w-32 h-32 bg-blue-500 rounded-3xl -z-10"></div>
            </div>
          </div>

          {/* Highlights Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {highlights.map((item, index) => (
              <div 
                key={index}
                className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 text-center"
              >
                <div className="flex justify-center mb-4">
                  <div className={`w-16 h-16 bg-gradient-to-br ${item.color} rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <item.icon className="w-8 h-8 text-white" />
                  </div>
                </div>
                <p className="text-sm font-semibold text-gray-800">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
